export default "__VITE_ASSET__ChSuEYB6__"